"use client";
import Link from "next/link";
import { ChevronRight } from "lucide-react";
import React from "react";
const BreadCrum = ({ breadcrumbs }) => {
  return (
    <div className="relative w-full">
      <nav
        aria-label="Breadcrumb"
        className="overflow-x-auto md:overflow-visible"
      >
        <ol className="flex min-w-max items-center gap-1.5 whitespace-nowrap px-[5%] py-2 text-black md:h-[40px] md:min-w-0 md:gap-2 md:px-[8%] md:py-4">
          {breadcrumbs.map((item, index) => (
            <li
              key={index}
              className="flex items-center gap-1.5 text-xs md:gap-2 md:text-xs"
              aria-current={index === breadcrumbs.length - 1 ? "page" : undefined}
            >
              {index > 0 && (
                <span className="shrink-0 text-gray-400" aria-hidden="true">
                  <ChevronRight className="size-3.5 md:size-5" />
                </span>
              )}
              {item.link ? (
                <Link
                  href={item.link}
                  title={item.title}
                  className="transition-colors bg-black text-white px-2 py-0.5 rounded-full text-[10px] font-medium md:text-xs whitespace-nowrap hover:bg-[#4C9170]"
                >
                  {item.title}
                </Link>
              ) : (
                <span className="max-w-[180px] truncate font-medium sm:max-w-[280px] md:max-w-none">
                  {item.title}
                </span>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </div>
  );
};

export default BreadCrum;
